import React from "react";
import { LogoMark } from "@/components/LogoMark";

export const Loader = () => (
  <div className="grid min-h-[100svh] place-items-center bg-[#F8FAFC]" data-testid="loader">
    <div className="flex flex-col items-center gap-5">
      <LogoMark className="h-10 animate-fade-in" />
      <span className="h-6 w-6 animate-spin rounded-full border-2 border-slate-200 border-t-[#D4AF37]" />
    </div>
  </div>
);
